import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatToolbarModule } from "@angular/material/toolbar";
import { TranslateModule } from "@ngx-translate/core";

import { FuseSharedModule } from "@fuse/shared.module";

import { BrowserNotificationDialogComponent } from "app/layout/components/toolbar/browser-notification-dialog/browser-notification-dialog.component";
import { ToolbarComponent } from "app/layout/components/toolbar/toolbar.component";

@NgModule({
    declarations: [ToolbarComponent, BrowserNotificationDialogComponent],
    imports: [
        RouterModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatToolbarModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatOptionModule,
        TranslateModule,

        FuseSharedModule,
    ],
    exports: [ToolbarComponent],
})
export class ToolbarModule {}
